import React from "react";
import { Icon } from "../";
import { useGlobalUtils } from "@finitless/shared/lib";

const OverviewTab = ({ user }) => {
  const { parseDate } = useGlobalUtils();

  const name =
    user?.name && user?.lastname
      ? `${user.name} ${user.lastname}`
      : user?.name || "Unknown";

  const phone =
    user?.country_phone_code && user?.cellphone
      ? `+${user.country_phone_code} ${user.cellphone}`
      : user?.cellphone || "N/A";

  const email = user?.email || "N/A";

  return (
    <div className="space-y-6">
      {/* User Info */}
      <div className="rounded-lg border border-gray-700 bg-gray-800 p-6">
        <h3 className="mb-4 flex items-center text-lg font-semibold text-white">
          <Icon name="User" className="mr-2 h-5 w-5" />
          Driver Manager Info
        </h3>
        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-400">Name:</span>
            <span className="text-white">{name}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Phone:</span>
            <span className="text-white">{phone}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Email:</span>
            <span className="text-white">{email}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Status:</span>
            <span
              className={`rounded-full px-2 py-1 text-xs font-medium ${
                user?.enabled
                  ? "border border-green-500/20 bg-green-500/20 text-green-400"
                  : "border border-red-500/20 bg-red-500/20 text-red-400"
              }`}
            >
              {user?.enabled ? "Active" : "Inactive"}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-400">Joined:</span>
            <span className="text-white">{parseDate(user?.created_at)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
